var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 790,
    viewBox: "0 0 520 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-269.595.758h56.368c88.702 2.813 178.656 37.395 245.48 103.756 46.075 45.756 76.935 119.377 92.585 190.1 15.656-70.728 46.51-144.344 92.586-190.1C284.247 38.153 374.207 3.571 462.909.758h56.367v15.089c-1.994 101.248-28.679 205.225-106.591 282.571-51.688 51.33-115.207 83.462-181.829 96.775 66.617 13.319 130.141 45.446 181.829 96.776 77.912 77.345 104.597 181.323 106.591 282.571v15.089h-56.367c-88.702-2.813-178.656-37.395-245.48-103.756-46.075-45.756-76.935-119.377-92.586-190.1-15.655 70.728-46.51 144.344-92.585 190.1-66.819 66.355-156.778 100.937-245.48 103.756h-56.368l.001-788.871h-.006z",
    fill: "#F7F3FF"
  })));
}
export default SvgBottomIllustration;